(ns app.front.view.group.admin.form-schemas.declaration-editor
  (:require [app.domain.form.form-editor-util :as form-editor-util]
            [app.domain.party-role.model :as role-model]
            [app.domain.sign-off.declarations :as sign-off-declarations]
            [app.front.entities :as entities]
            [app.front.form.render :as fr]
            [app.front.form.render-edit :as fre]
            [app.front.ui :as ui]
            [app.front.ui.error-boundary :as eb]
            [app.front.ui.select :as ui-select]
            [app.front.ui.template-editor :as template-editor]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.form-schemas.subs :as form-schemas-subs]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.subs :as group-subs]
            [app.front.view.not-found :as not-found]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))


(rf/reg-event-fx ::save-schema
  (fn [{:keys [db]} [_ group-id declaration-id]]
    (let [new?        (= declaration-id "new")
          new-name    (get-in db [::editor-data :declaration-config/name])
          new-role    (get-in db [::editor-data :declaration-config/party-role])
          data-schema (-> (get-in db [::form-schemas-subs/form-schema :editor-data])
                          form-editor-util/map-presentation->schema-data)]
      {:comm/command {:command    :group/save-declaration-config
                      :method     :post
                      :data       (merge {:authority-group-id             group-id
                                          :declaration-config/data-schema data-schema
                                          :declaration-config/name        new-name
                                          :declaration-config/party-role  new-role}
                                         (when-not new?
                                           {:declaration-id (futil/parse-int declaration-id)}))
                      :on-success [::save-schema.success group-id new?]
                      :notify     {:success :declaration-config.admin/save-success}}})))


(rf/reg-event-fx ::save-schema.success
  (fn [_ [_ group-id new? status changes]]
    {:fx [[:dispatch [::entities/apply-changes status changes]]
          [:dispatch [::cancel-editing group-id new?]]]}))


(rf/reg-event-db ::set-editor-data
  (fn [db [_ {:declaration-config/keys [data-schema name] :as declaration}]]
    (p/deep-merge (form-schemas-subs/set-editor-data
                    (util/mmap {:schema-name         name
                                :editing-schema?     true
                                :editor-data         (form-editor-util/schema-data->map data-schema)
                                :override-curr-data? true}
                               db
                               data-schema))
                  {::editing?                      true
                   ::form-schemas-subs/form-schema {:id-of-selected-form-el 0}
                   ::editor-data                   (-> declaration
                                                       (select-keys [:declaration-config/name
                                                                     :declaration-config/party-role])
                                                       (update :declaration-config/party-role :db/id))})))


(rf/reg-event-fx ::cancel-editing
  (fn [{:keys [db]} [_ group-id new?]]
    (merge {:db       (assoc db
                             ::editing? false
                             ::editor-data nil)
            :dispatch [::form-schemas-subs/cancel-form-edit]}
           (when new?
             {:route/push {:route  :view/group.admin.forms
                           :params {:group-id group-id}}}))))


(rf/reg-event-db ::set-attr-value
  (fn [db [_ k v]]
    (assoc-in db [::editor-data k] v)))


(rf/reg-sub ::editing? :-> ::editing?)


(rf/reg-sub ::local-editor-data :-> ::editor-data)


(rf/reg-sub ::available-roles
  (fn [[_ group-id]]
    [(rf/subscribe [:language])
     (rf/subscribe [::group-subs/available-party-roles group-id])])
  (fn [[lang party-roles] _]
    (sort-by #(role-model/party-role-name % lang)
             party-roles)))


(rf/reg-sub ::editor-text-data
  :<- [::form-schemas-subs/editor-data]
  (fn [editor-data _]
    (->> editor-data
         form-editor-util/form-el->children
         (mapcat form-editor-util/form-el->children)
         (mapcat form-editor-util/form-el->children)
         (keep :text-value)
         (str/join " "))))


(defn configuration-box [{:keys [tr] :as ctx}]
  [:div
   {:class ""}
   (let [selected-element (<sub [::form-schemas-subs/selected-form-element])
         parent-type      (-> (<sub [::form-schemas-subs/form-element-by-path
                                     (form-editor-util/form-el->parent-path selected-element)])
                              :type)]
     (if selected-element
       [:<>
        [:h3.text-center.mr-1.mb-4.font-bold.text-base.flex-auto (tr [:form.schema/field-configuration])]
        [fre/form-element-edit-view ctx selected-element parent-type false]]
       [:h4.text-center.mr-1.mb-2.font-bold.text-base.flex-auto (tr [:form.schema/select-help-text])]))])


(def available-placeholders
  (->> (keys sign-off-declarations/placeholder->ctx-path)
       (map #(str/replace % "%" ""))
       sort
       (map #(hash-map :id %))))


(defn schema-content [{:keys [edit? json-schema-data hiccup-schema-data ctx tr]}]
  [:div
   (when-not edit?
     [:div.-mt-4
      [fr/render ctx 0 nil hiccup-schema-data]
      [:div.flex.mt-6
       (cc/button
         {:kind             :primary
          :icon             i/undersign
          :icon-description (tr [:signature/sign-off])}
         (tr [:signature/sign-off]))]])
   (when (and edit? json-schema-data)
     (let [[_bad-placeholders
            used-placeholders] (template-editor/summarize-placeholders
                                 available-placeholders
                                 []
                                 (<sub [::editor-text-data]))]
       [:<>
        [:p (tr [:declaration-config.admin/editor-guide-2])]
        [:div.flex.flex-wrap
         [:div.w-full.lg:w-1-3.lg:pr-6
          [template-editor/placeholders-list
           tr
           :declaration-config.admin/editor-placeholders
           available-placeholders
           used-placeholders]]
         [:div.w-full.lg:w-2-3
          [configuration-box {:tr tr}]]]]))])


(defn default-declaration [group-id]
  {:declaration-config/name        "New sign-off declaration"
   :declaration-config/party-role  (-> (<sub [::available-roles group-id])
                                       (p/find-first {:party-role/key :role/applicant}))
   :declaration-config/data-schema sign-off-declarations/default-declaration-schema})


(defn view [{{{:keys [declaration-id group-id]} :path} :parameters :as match}]
  (let [new?        (= declaration-id "new")
        party-roles (<sub [::available-roles group-id])
        declaration (if new?
                      (default-declaration group-id)
                      (when-let [id (futil/parse-int declaration-id)]
                        (<sub [::entities/entity id])))
        data-schema (:declaration-config/data-schema declaration)
        tr          (<sub [:tr])
        lang        (<sub [:language])
        editing?    (or new?
                        (<sub [::editing?]))
        editor-data (<sub [::local-editor-data])
        ctx         (util/mmap {:preview? true
                                :lang     lang
                                :role     (:declaration-config/party-role (or editor-data declaration))
                                :party    {:full-name (tr [:declaration-config.admin/dummy-party-name])}}
                               tr group-id)]
    (if declaration
      [acommon/admin-page
       {:match match
        :title (tr [:declaration-config.admin/page-title])}
       [:section
        (if editing?
          [:div.flex.justify-between.mb-8
           [:div.flex.flex-0.flex-col.w-full.lg:w-2-3
            [:div.w-full
             [:p (tr [:declaration-config.admin/editor-guide-1])]]
            [:div.flex.flex-row.flex-wrap.w-full
             [ui/text-input {:id         (str declaration-id "-name")
                             :class      "mr-2"
                             :label-text (tr [:declaration-config.admin/name-label])
                             :on-change  #(rf/dispatch-sync [::set-attr-value :declaration-config/name (futil/tval %)])
                             :value      (:declaration-config/name editor-data)}]
             [ui-select/select {:id           (str declaration-id "-role")
                                :value        (-> editor-data :declaration-config/party-role)
                                :allow-empty? false
                                :values       (map :db/id party-roles)
                                :select-text  (tr [:select/select])
                                :label-text   (tr [:declaration-config.admin/role-label])
                                :val->str     #(-> party-roles
                                                   (p/find-first {:db/id %})
                                                   (role-model/party-role-name lang))
                                :on-change    #(>evt [::set-attr-value :declaration-config/party-role %])}]]]
           [:div.w-64.flex-none.flex.justify-end.items-start
            (cc/button
              {:on-click   #(>evt [::cancel-editing group-id new?])
               :class-name "mr-2"
               :icon       i/remove
               :kind       :tertiary}
              (tr [:cancel]))
            (cc/button
              {:on-click #(>evt [::save-schema group-id declaration-id])
               :disabled (str/blank? (:declaration-config/name editor-data))
               :icon     i/save}
              (tr [:save]))]]
          [:div.flex.justify-between
           [:h2 (:declaration-config/name declaration)]
           [:div
            (cc/button
              {:on-click #(>evt [::set-editor-data declaration])
               :icon     i/pen}
              (tr [:edit]))]])
        [eb/error-boundary
         [:<>
          [schema-content (util/mmap {:edit?              editing?
                                      :json-schema-data   (get (form-editor-util/schema-data->map data-schema) 0)
                                      :hiccup-schema-data data-schema}
                                     ctx tr)]]]]]
      [not-found/not-found-view])))


(def route
  {:name        :view/group.admin.declaration-editor
   :view        view
   :parameters  {:path {:group-id       s/Int
                        :declaration-id s/Str}}
   :controllers [{:parameters {:path [:group-id :declaration-id]}
                  :start      (fn [{{:keys [declaration-id group-id]} :path}]
                                (>evt [::gas/fetch-party-roles group-id])
                                (if (= declaration-id "new")
                                  (>evt [::set-editor-data (default-declaration group-id)])
                                  (>evt [::cancel-editing])))}]})
